import { useQuery, UseQueryOptions } from 'react-query';

import SampleFile from '@app/store/documents/SampleFile';
import { getSampleDocuments } from '@app/store/transport-layer/cdn/sample-documents/list';

export default function useSampleDocumentList(options?: UseQueryOptions<SampleFile[], Error>) {
  return useQuery<SampleFile[], Error>(
    ['uploadModalSampleDocumentList'],
    async () => {
      return getSampleDocuments();
    },
    options
  );
}
